import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/site/Logo";
import { btnPrimary } from "@/components/site/buttons";
import { Seo } from "@/components/site/Seo";

export default function AdminLogin() {
  const { user, ready, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (ready && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  const field = "mt-2 w-full rounded-none border border-ink/20 bg-white px-4 py-3 font-sans text-sm text-ink focus:border-gold-500 focus:outline-none";

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream-200 px-5">
      <Seo title="Administrator" noindex />
      <div className="w-full max-w-md">
        <div className="mb-8 text-center"><Logo /></div>
        <div className="border border-ink/10 bg-cream-100 p-8 shadow-[0_8px_32px_rgba(26,37,48,0.08)]">
          <h1 className="font-serif text-3xl font-light text-ink">Administrator</h1>
          <p className="mt-2 font-sans text-sm text-steel-500">Sign in to manage articles, videos and inquiries.</p>
          <form onSubmit={submit} className="mt-6" data-testid="admin-login-form">
            <label className="font-sans text-sm font-medium text-ink" htmlFor="email">Email</label>
            <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={field} data-testid="login-email" required />
            <label className="mt-5 block font-sans text-sm font-medium text-ink" htmlFor="password">Password</label>
            <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={field} data-testid="login-password" required />
            {error && <p className="mt-4 font-sans text-sm text-destructive" data-testid="login-error">{error}</p>}
            <button type="submit" disabled={loading} className={`mt-7 w-full ${btnPrimary} disabled:opacity-60`} data-testid="login-submit">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
